<template>
  <div class="metric-card" :class="{ 'metric-card--loading': loading }">
    <p class="metric-card__title" :class="description ? 'info-help' : ''">
      <span>{{ title }}</span>
      <v-tooltip bottom v-if="description">
        <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="#212338"
              size="22"
              class="ml-3"
              light
              v-bind="attrs"
              v-on="on"
              >
              mdi-help-circle-outline
              </v-icon>
        </template>
        <p style="max-width: 430px">
          <span>{{ description }}</span>
        </p>
      </v-tooltip>

    </p>
    <div class="metric-card__price-wrapper">
      <h4 class="metric-card__pr d-block w-full">
         <div class="d-flex justify-space-between" v-if="valueCurrent">
            <slot
               :current="valueCurrent"
               :sign="valueSign"
               name="value"
            />
            <span v-if="show_placeholders && valuePrev" class="metric-card__percent" :class="((valueCurrent - (valuePrev) ) /  (valuePrev)) < 0 ? 'metric-card__percent-red' : 'metric-card__percent-green'">
                <svg :style="((valueCurrent - (valuePrev) ) /  (valuePrev || 452)) < 0 ? 'transform: rotateX(180deg)' : ''" width="10" height="11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 4.699l.922.935 3.12-3.12V12h1.314V2.514l3.12 3.12.922-.935L4.699 0 0 4.699z" fill="#3ACA56"/></svg>
                 {{((valueCurrent - (valuePrev) ) /  (valuePrev)  * 100).toFixed(1)}}%
            </span>
         </div>
        <template v-else>-</template>
      </h4>
      <sup
         v-if="show_placeholders"
        class="metric-card__progress"
        :class="{ 'positive': difference && isPositive, 'negative': difference && !isPositive }"
      >
        {{ (difference) && (Math.abs(difference) + '%') }}
      </sup>
    </div>
    <template  v-if="show_placeholders">
      <div class="start-end-wrapper">
         <span>0</span>
         <span>100</span>
      </div>
      <div class="metric-card__progress-bar-wrapper">
         <span class="progress" :style="{ width: 0 + '%' }"></span>
      </div>
      <p class="metric-card__title-bottom mb-0">Industry Rank</p>
      <button
         v-if="hasInfo && show_placeholders"
         class="info-btn"
         @click="$emit('clickInfo')"
      ></button>
    </template>
  </div>
</template>

<script>
// var show_placeholders = process.env.VUE_APP_SHOW_PLACEHOLDERS == 'true'
var show_placeholders = false

export default {
  name: 'CardMetric',
  props: {
    title: {
      type: String,
      default: '-'
    },
    description: {
      type: String,
      default: null
    },
    valueSign: {
      type: String,
      default: ''
    },
    valueCurrent: {
      type: [String, Number],
      default: ''
    },
    valuePrev: {
      type: [String, Number],
      default: '-'
    },
    difference: {
      type: [String, Number],
      default: ''
    },
    hasInfo: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show_placeholders
    }
  },
  computed: {
    isPositive () {
      return this.difference > 0
    }
  }
}
</script>

<style lang="scss" scoped>
  .metric-card {
    position: relative;
    background: linear-gradient(180deg, #FFFFFF 0%, #F4F7F9 88.07%);
    overflow: hidden;
    border-radius: 15px;
    padding: 22px 22px;
    color: $black-color;
    border: linear-gradient(180deg, #FFFFFF 0%, #F4F7F9 88.07%);

    &--loading {
      &:after {
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
        -webkit-animation: loading 1.5s infinite;
        animation: loading 1.5s infinite;
        content: "";
        height: 100%;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(-100%);
        z-index: 1;
      }
    }
    .metric-card__title {
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 0px;
      font-weight: 500;
      height: 30px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      &.info-help {
        display: flex;
        align-items: flex-start;
        span {
          flex: 1;
          overflow: hidden;
          padding-right: 10px;
          text-overflow: ellipsis;
        }
        i.v-icon {
          justify-content: flex-end;
          position: absolute;
          right: 10px;
        }
      }
    }
    .metric-card__title-bottom {
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      margin-bottom: 12px;
    }
    .metric-card__price-wrapper {
      display: flex;
      position: relative;
      justify-content: center;
      width: 100%;
      margin: auto;
    }
    .metric-card__pr {
      font-weight: 600;
      font-size: 24px;
      width: 100%;
      line-height: 1;
    }

    .metric-card__percent {
      font-weight: normal;
      font-size: 13px;

      svg {
         position: relative;

      }

      &-green {
         color: #3ACA56;

         svg path {
            fill: #3ACA56;
         }
      }

      &-red {
         color: #CA3A3A;

         svg {
            transform: rotate(180deg);
         }
         svg path {
            fill: #CA3A3A !important;
         }
      }
    }
    .metric-card__progress {
      display: flex;
      font-size: 12px;
      line-height: 14px;
      color: #FFFFFF;
      opacity: 0.5;
      position: absolute;
      right: -40px;
      &.positive:before, &.negative:before {
        content: '';
        position: relative;
        display: block;
        background-image: url("data:image/svg+xml,%0A%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath opacity='0.5' d='M8.00014 11.3335L4.00014 11.3335L4.00014 6.00016L0.773473 6.00016L6.00014 0.773495L11.2268 6.00016L8.00014 6.00016L8.00014 11.3335Z' fill='white'/%3E%3C/svg%3E%0A");
        width: 11px;
        height: 11px;
        margin: 0 3px 0 5px;
      }
      &.negative:before {
        background-image: url("data:image/svg+xml,%0A%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath opacity='0.5' d='M3.99986 0.666504L7.99986 0.666504L7.99986 5.99984H11.2265L5.99986 11.2265L0.773193 5.99984H3.99986L3.99986 0.666504Z' fill='white'/%3E%3C/svg%3E%0A");
      }
    }
    .metric-card__progress-bar-wrapper {
      height: 6px;
      border-radius: 10px;
      overflow: hidden;
      background: #C1D0C4;
      margin: 0 0 11px 0;
      .progress {
        display: block;
        background: #fff;
        height: 6px;
        border-radius: 10px;
      }
    }
    .start-end-wrapper {
      display: flex;
      justify-content: space-between;
      margin: 7px 0 5px 0;
      span {
        font-weight: normal;
        font-size: 13px;
        line-height: 16px;
        color: $black-color;
      }
    }
    .info-btn {
      position: absolute;
      bottom: 6px;
      right: 6px;
      width: 12px;
      height: 12px;
      border-radius: 20px;
      background-color: rgb(255, 255, 255, 0.5);
      &:focus {
        outline: none;
      }
    }
  }
</style>
